var B = Object.defineProperty, E = Object.defineProperties;
var F = Object.getOwnPropertyDescriptors;
var O = Object.getOwnPropertySymbols;
var K = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var U = (r, s, e) => s in r ? B(r, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[s] = e, h = (r, s) => {
  for (var e in s || (s = {}))
    K.call(s, e) && U(r, e, s[e]);
  if (O)
    for (var e of O(s))
      P.call(s, e) && U(r, e, s[e]);
  return r;
}, v = (r, s) => E(r, F(s));
var b = (r, s, e) => new Promise((f, y) => {
  var x = (i) => {
    try {
      n(e.next(i));
    } catch (l) {
      y(l);
    }
  }, a = (i) => {
    try {
      n(e.throw(i));
    } catch (l) {
      y(l);
    }
  }, n = (i) => i.done ? f(i.value) : Promise.resolve(i.value).then(x, a);
  n((e = e.apply(r, s)).next());
});
import { u as S, a as j } from "./query-client-DZ5Df1It.js";
import { m as w, q as N, r as z } from "./define-element-XpjsV6s1.js";
import { i as D } from "./utils-CMsllPx8.js";
import { u as G } from "./use-cart-D8NOb7eE.js";
import { u as H } from "./use-user-CwEHAZOt.js";
import { s as A, a as I } from "./use-product-y102e61c.js";
function J() {
  const r = H();
  return w(() => {
    var s, e;
    if (!r.isPending.value)
      return r.isError.value ? null : (e = (s = r.data.value) == null ? void 0 : s.id) != null ? e : null;
  });
}
function M(r) {
  const s = J();
  let e;
  N(
    s,
    (f) => {
      f !== void 0 && (e !== void 0 && f !== e && r(), e = f);
    },
    { immediate: !0 }
  );
}
function ee() {
  const r = S(), { cart: s } = G();
  M(() => {
    r == null || r.invalidateQueries({ queryKey: ["offering"] });
  });
  const e = j({
    queryKey: ["offering"],
    queryFn: () => b(null, null, function* () {
      try {
        const a = yield z("cart/customer/allocation");
        return a != null && a.error ? { products: [], authRequired: !1 } : { products: Array.isArray(a) ? a : Object.values(a), authRequired: !1 };
      } catch (a) {
        if (a instanceof Error && a.message === "Authentication Required")
          return { products: [], authRequired: !0 };
        throw a;
      }
    })
  }), f = w(() => {
    var a, n;
    return (n = (a = e.data.value) == null ? void 0 : a.authRequired) != null ? n : !1;
  }), y = w(() => {
    var n, i;
    const a = {};
    for (const l of (n = s.value.items) != null ? n : [])
      a[l.sku] = (i = l.quantity) != null ? i : 0;
    return a;
  }), x = w(() => {
    var n, i, l;
    let a = ((i = (n = e.data.value) == null ? void 0 : n.products) != null ? i : []).map((t) => {
      var c, u, o, m, p, q, _, g, C, Q;
      return v(h({}, t), {
        min_quantity: parseInt((c = t.min_quantity) != null ? c : "0", 10),
        max_quantity: parseInt((u = t.max_quantity) != null ? u : "0", 10),
        // Allocation ceiling before any inventory clamp — mirrors PHP's
        // add_allocation() bulk action, which adds this raw quantity as-is.
        quantity: parseInt((o = t.quantity) != null ? o : "0", 10),
        min_wish: parseInt((m = t.min_wish) != null ? m : "0", 10),
        max_wish: parseInt((p = t.max_wish) != null ? p : "0", 10),
        allocation_start: (q = t.allocation_start) != null ? q : "",
        allocation_end: (_ = t.allocation_end) != null ? _ : "",
        // Inventory-clamped purchase ceiling — mirrors
        // cart-quantity-add.tpl.php's min(allocation, inventory).
        max_purchasable: Number.isFinite(t.max_purchasable) ? t.max_purchasable : parseInt((g = t.max_quantity) != null ? g : "0", 10),
        cartQty: (C = y.value[t.sku]) != null ? C : 0,
        variants: ((Q = t.variants) != null ? Q : []).map((d) => {
          var R, k, L;
          return v(h({}, d), {
            min_quantity: parseInt((R = d.min_quantity) != null ? R : "0", 10),
            max_quantity: parseInt((k = d.max_quantity) != null ? k : "0", 10),
            cartQty: (L = y.value[d.sku]) != null ? L : 0
          });
        })
      });
    });
    if (!D(A.value)) {
      const t = A.value.toLowerCase();
      a = a.filter(
        (c) => {
          var u, o, m;
          return ((u = c.name) != null ? u : "").toLowerCase().includes(t) || ((o = c.label) != null ? o : "").toLowerCase().includes(t) || ((m = c.description) != null ? m : "").toLowerCase().includes(t);
        }
      );
    }
    if (I.value[0]) {
      const t = I.value[0], c = (l = I.value[1]) != null ? l : "asc";
      a.sort((u, o) => {
        var m, p, q, _;
        return t === "price" ? c === "asc" ? u.price - o.price : o.price - u.price : c === "asc" ? ((m = u[t]) != null ? m : "").localeCompare((p = o[t]) != null ? p : "") : ((q = o[t]) != null ? q : "").localeCompare((_ = u[t]) != null ? _ : "");
      });
    } else
      a.reverse();
    return a;
  });
  return v(h({}, e), {
    offeringProducts: x,
    authRequired: f
  });
}
export {
  M as o,
  ee as u
};
